<template>
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.4596 12.9598C18.7135 12.706 18.7135 12.2944 18.4596 12.0406L14.323 7.90399C14.0692 7.65015 13.6576 7.65015 13.4038 7.90399C13.15 8.15783 13.15 8.56939 13.4038 8.82323L17.0808 12.5002L13.4038 16.1771C13.15 16.431 13.15 16.8425 13.4038 17.0964C13.6576 17.3502 14.0692 17.3502 14.323 17.0964L18.4596 12.9598ZM7 13.1502L18 13.1502L18 11.8502L7 11.8502L7 13.1502Z"
      fill="currentColor"
    />
  </svg>
</template>
